/**
 * BuyNow Controller
 *
 * Author: Oded Sagir
 * @param  Object require -for adding dependencies
 * @return Object         -Class Object
 */
define(function (require) {
    'use strict';

    var LE = require('app');
    var Loader = require("ui/loader/Loader");
    var LEConfig = require("assets/config/le-env-conf");
    var errorCodes = require("registration-assets/data/errorCodes.json");

    // MODEL
    var BaseModel = require("models/BaseModel");
    var ZuoraIFrameSourceModel = require("registration-models/ZuoraIFrameSourceModel");
    var RegistrationLeadModel = require("registration-models/RegistrationLeadModel");
    var AccountModel = require("registration-models/AccountModel");

    // VIEW
    var Page = require("ui.components/page/Page");
    var BuyNowInfoView = require("registration-views/buy-now/BuyNowInfoView");
    var AutoLoginView = require("registration-views/AutoLoginView");
    var BuyNowConfirmationView = require("registration-views/buy-now/BuyNowConfirmationView");

    // UTILS
    var RegistrationObjectUtil = require("registration-utils/RegistrationObjectUtil");
    var RegistrationStorageUtil = require("registration-utils/RegistrationStorageUtil");
    var GoogleAnalytics = require("registration-google/GoogleAnalytics");
    var DomUtil = require("infra-util/DomUtilities");

    var BuyNowController = {};
    LE.module("LERegistration", function (LERegistration, LE, Backbone, Marionette, $, _) {
        BuyNowController = Marionette.Controller.extend({

            initialize: function (options) {
                LERegistration.logger.info("Initializing BuyNowController", "BuyNowController:initialize");

                this.vent = options.vent;
                this.controller = options.controller;

                this.zuoraIFrameSourceModel = new ZuoraIFrameSourceModel();
                this.flowModel = this.controller.flowModel;

            },

            //-------------------------------------------------------------------------

            showBuyNowInfo: function (args) {
                LERegistration.logger.info("Function Start", "BuyNowController:showBuyNowInfo");
                this.flowModel.unset('creditCardRef');
                this.controller.isShowDetails = false;
                this.flowModel.set({
                    "language": args.language,
                    "source": args.source,
                    "flow": args.flow,
                    "currency": args.currency,
                    "planName": args.planName,
                    "campaignSearchKeywords": args.campaignSearchKeywords,
                    "campaignSource": args.campaignSource,
                    "campaignReferrer": args.campaignReferrer,
                    "campaignId": args.campaignId,
                    "roiaValue": args.roiaValue
                });
                RegistrationStorageUtil.saveAffiliateQueryParams(args);
                //un-setting the password in case we returned to the page with the back button.
                this.flowModel.unset("password");
                var buyNowInfoView = new BuyNowInfoView({
                    model: this.flowModel
                });
                var buyNowInfoViewPage = new Page({
                    moduleName: LERegistration.moduleName,
                    context: LE.context,
                    view: buyNowInfoView,
                    permutation: Page.PERMUTATION.Custom
                });
                this.listenTo(buyNowInfoView, BuyNowInfoView.TRIGGERING.NEXT_BUTTON_CLICKED, _.bind(this._onInfoNextButtonClick, this));
                var deferred = this.controller.billingManager.getPlanDetailsByFlowModelPlanName(this.flowModel);
                $.when(deferred).done(_.bind(function (flowModel) {
                    flowModel.set("pendingPlan", flowModel.get("currentPlan"));
                    flowModel.unset("currentPlan");
                }, this))
                .fail(_.bind(function (message, errorCode) {
                    message = "error fetching billing pricing data" + message;
                    var returnPage = RegistrationStorageUtil.CONSTANT.RETURN_PAGE_BUYNOW;
                    this.controller.handleRegistrationError(message, errorCode, returnPage);
                }, this));
                this.controller.showViewInMainRegion(buyNowInfoViewPage);
                LERegistration.logger.info("Function End", "BuyNowController:showBuyNowInfo");
            },

            showBuyNowCheckout: function () {
                LERegistration.logger.info("Function Start", "BuyNowController:showBuyNowCheckout");
                if (this.flowModel.get("planName") && this.flowModel.get("password") && this.flowModel.get("crmDetails.email")) {
                    if (this.flowModel.get("creditCardRef") || this.controller.isShowDetails) { //means that it is not the first time we enter the page, so we need to clear the ccRef and retain the values.
                        LERegistration.logger.info("unset creditCardRef when we arrive to the page second time (Browser back button)", "BuyNowController:showBuyNowCheckout");
                        this.flowModel.unset("creditCardRef");
                        this.controller.billingManager.fetchZuoraIframeSource(this.flowModel, true, null, "buyNow");
                    } else {
                        this.controller.billingManager.fetchZuoraIframeSource(this.flowModel, false, null, "buyNow");
                    }
                } else {
                    LERegistration.logger.info("BuyNowController >> showBuyNowCheckout >> navigate >> buyNow");
                    LERegistration.router.navigate("buyNow");
                }
                LERegistration.logger.info("Function End", "BuyNowController:showBuyNowCheckout");
            },

            showBuyNowConfirmation: function () {
                LERegistration.logger.info("Function Start", "BuyNowController:showBuyNowConfirmaton");
                if (this.flowModel.get("creditCardRef")) {
                    this.controller.isShowDetails = true;
                    this.controller.showLoader();
                    this.getCcDetails();
                } else {
                    LERegistration.logger.info("navigating to buyNowCheckout", "BuyNowController:showBuyNowConfirmation");
                    LERegistration.router.navigate("buyNowCheckout");
                }
                LERegistration.logger.info("Function End", "BuyNowController:showBuyNowConfirmaton");
            },

            getCcDetails: function () {
                this.flowModel.unset("creditCardDetails");
                var promises = [];
                promises.push(this.controller.billingManager.getCreditCardDetails(this.flowModel));
                promises.push(this.controller.billingManager.getTerm());

                $.when.apply($, promises).then(_.bind(function (flowModel, term) {
                        var pagePermutation = Page.PERMUTATION.Custom;
                        if (LE.sessionManager.isAuthenticated()) {
                            pagePermutation = Page.PERMUTATION.Dialog;
                        }
                        var buyNowConfirmationInnerView = new BuyNowConfirmationView({
                            model: flowModel,
                            flowType: "buyNow",
                            term: term
                        });
                        var buyNowConfirmationView = new Page({
                            moduleName: LERegistration.moduleName,
                            context: LE.context,
                            view: buyNowConfirmationInnerView,
                            permutation: pagePermutation
                        });
                        this.listenTo(buyNowConfirmationInnerView, BuyNowConfirmationView.TRIGGERING.CANCEL_BUTTON_CLICKED, _.bind(function () {
                            this.controller.routeToPrevious();
                        }, this));
                        this.listenTo(buyNowConfirmationInnerView, BuyNowConfirmationView.TRIGGERING.CONFIRM_BUTTON_CLICKED, _.bind(function () {
                            this.controller.showLoader();
                            this.confirmPurchase(); //unique to BuyNowController
                        }, this));
                        this.controller.showViewInMainRegion(buyNowConfirmationView);
                        this.controller.closeLoader();
                    }, this),
                    _.bind(function (message, errorCode) {
                        message = "error fetching billing pricing data : " + message;
                        var returnPage = (LE.sessionManager.isAuthenticated() ? "changePlanCheckout" : RegistrationStorageUtil.CONSTANT.RETURN_PAGE_BUYNOW);
                        this.controller.handleRegistrationError(message, errorCode, returnPage);
                    }, this));

            },

            confirmPurchase: function () {
                // sending an event to Google Analytics to notify this an account was created
                GoogleAnalytics._runGoogleAnalyticsEvent('BuyNowCompleted');

                var accountModel = new AccountModel();
                accountModel.set("ratePlanName", this.flowModel.get("planName"));
                accountModel.set("email", this.flowModel.get("crmDetails.email"));
                accountModel.set("firstName", this.flowModel.get("crmDetails.firstName"));
                accountModel.set("lastName", this.flowModel.get("crmDetails.lastName"));
                accountModel.set("website", this.flowModel.get("crmDetails.website"));
                accountModel.set("password", this.flowModel.get("password"));
                accountModel.set("location", this.flowModel.get("location"));
                accountModel.set("industry", this.flowModel.get("industry"));
                accountModel.set("language", this.flowModel.get("language"));
                accountModel.set("productName", RegistrationStorageUtil.CONSTANT.DEFAULT_PRODUCT_NAME);
                accountModel.set("creditCardRef", this.flowModel.get("creditCardRef"));
                accountModel.set("currency", this.flowModel.get("currency"));
                accountModel.set("flow", RegistrationStorageUtil.CONSTANT.BUY_FLOW);

                try {
                    var impactRadiusData = RegistrationStorageUtil.getDataFromStorage(RegistrationStorageUtil.CONSTANT.IMPACT_RADIUS_DATA);
                    if (impactRadiusData) {
                        accountModel.set(RegistrationStorageUtil.CONSTANT.AFFILIATE_ID, impactRadiusData.affiliateId);
                        accountModel.set(RegistrationStorageUtil.CONSTANT.CLICK_ID, impactRadiusData.clickId);
                    }
                } catch (ex) {
                    LERegistration.logger.error("exception in fetching impactRadiusData", "BuyNowController:confirmPurchase", ex);
                }
                try {
                    DomUtil.injectImgToBody("adwordsBuyRequest", "//www.googleadservices.com/pagead/conversion/1072532439/?value=" + this.buyNowConfirmationView.totalPayment + "&label=pOzuCMLAyQkQ15e2_wM&guid=ON&script=0");
                } catch (ex) {
                    LERegistration.logger.error("failed to send Adwords Conversion", "BuyNowController:confirmPurchase", ex);
                }
                try {
                    DomUtil.injectIframeToBody("bingBuyRequest", "//flex.msn.com/mstag/tag/5d4cc169-3ed0-47f3-9294-0fa49641be16/analytics.html?dedup=1&domainId=2872367&type=1&revenue=" + this.buyNowConfirmationView.totalPayment + "&actionid=261133");
                } catch (ex) {
                    LERegistration.logger.error("failed to send Bing Conversion", "BuyNowController:confirmPurchase", ex);
                }
                var options = {
                    success: _.bind(function (model) {
                        try {
                            model.set("password", this.flowModel.get("password"));
                            //do auto login
                            LERegistration.logger.info("RegistrationCreateAccountView >> _prepareLoginURL >> START and RETURN login url");
                            var loginUrl = "https://" + model.get("domain") + "/hc/s-" + model.get("siteId") + "/web/m-LP/mlogin/home.jsp";
                            var model1 = new BaseModel();
                            model1.set({"action": loginUrl});
                            model1.set({"siteId": model.get("siteId")});
                            model1.set({"userName": model.get("username")});
                            model1.set({"password": model.get("password")});
                            var autoLoginView = new AutoLoginView({model: model1});
                            this.controller.showViewInMainRegion(autoLoginView, true);
                            autoLoginView.submitForm();
                        } catch (ex) {
                            var message = "exception in login attempt after a successful buy now purchase";
                            var returnPage = RegistrationStorageUtil.CONSTANT.RETURN_PAGE_BUYNOW;
                            this.controller.handleRegistrationError(message, errorCodes.autoLoginFailedUponBuyNow, returnPage, {
                                "accountModel": accountModel,
                                "exception": ex
                            });
                        }
                    }, this),
                    error: _.bind(function (model, response) {
                        var errorCode = errorCodes.buyNowFailed;
                        var message = "Api failure in executing the buy now purchase.";
                        var returnPage = RegistrationStorageUtil.CONSTANT.RETURN_PAGE_BUYNOW;

                        this.controller.handleRegistrationError(message, errorCode, returnPage, {
                            "accountModel": accountModel,
                            "responseModel": model
                        }, response);
                    }, this)
                };
                accountModel.savePaid(options);
            },

            //-------------------------------------------------------------------------

            _onInfoNextButtonClick: function () {
                this.controller.showLoader();
                this._createLead();
                this.showBuyNowCheckout();
            },

            _createLead: function () {
                LERegistration.logger.info("start", "BuyNowController:_createLead");

                var registrationLeadModel = new RegistrationLeadModel();
                registrationLeadModel.set("firstName", this.flowModel.get("crmDetails.firstName"));
                registrationLeadModel.set("lastName", this.flowModel.get("crmDetails.lastName"));
                registrationLeadModel.set("email", this.flowModel.get("crmDetails.email"));
                registrationLeadModel.set("website", this.flowModel.get("crmDetails.website"));
                registrationLeadModel.set("location", this.flowModel.get("location"));
                //registrationLeadModel.set("industry", this.flowModel.get("industry"));
                registrationLeadModel.set("language", this.flowModel.get("language"));
                registrationLeadModel.set("origin", this.flowModel.get("origin"));
                registrationLeadModel.set("tier", this.flowModel.get("tier"));
                registrationLeadModel.set("frequency", this.flowModel.get("frequency"));
                registrationLeadModel.set("campaignSearchKeywords", this.flowModel.get("campaignSearchKeywords"));
                registrationLeadModel.set("campaignSource", this.flowModel.get("campaignSource"));
                registrationLeadModel.set("campaignReferrer", this.flowModel.get("campaignReferrer"));
                registrationLeadModel.set("campaignId", this.flowModel.get("campaignId"));
                registrationLeadModel.set("roiaValue", this.flowModel.get("roiaValue"));

                this.flowModel.unset("roiaValue");
                var options = {
                    success: function () {
                        LERegistration.logger.info("success creating lead", "BuyNowController:_createLead");
                        registrationLeadModel.unset("roiaValue");
                    },
                    error: function (model, response) {
                        var message = "BuyNow Lead failed to be saved. No action in client side taken.";
                        var errorCode = errorCodes.buyNowLeadApiFailed + ((response && response.responseError && (response.responseError.code || response.responseError.errorCode)) || response.status) + ".";
                        message += ".error code: " + errorCode;
                        message += ".server said: " + ((response && response.responseError && response.responseError.message) || response.statusText);
                        LERegistration.logger.error(message, "BuyNowController:_createLead", {
                            "model": model,
                            "registrationLeadModel": registrationLeadModel
                        });
                    }
                };

                registrationLeadModel.save(null, options);
                LERegistration.logger.info("end", "BuyNowController:_createLead");
            }

        });


    });
    return BuyNowController;
});
